export const CHART_PLACEHOLDER_HEIGHT = 427.5;
